module.exports = __webpack_public_path__ + "img/ele-out-25.5e16bcbd.png";